var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"fc3smpZYJUx07Mn7u8u4P"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/browser";
import {
  CaptureConsole as CaptureConsoleIntegration,
  // Offline as OfflineIntegration
} from "@sentry/integrations";

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;
const ENVIRONMENT = process.env.NEXT_PUBLIC_ENV || 'development';

Sentry.init({
  environment: ENVIRONMENT,
  dsn: SENTRY_DSN || 'https://7d261650bc8f476baf3b627c85ed9495@glitch.hiveon.net/8',
  tracesSampleRate: 0.25,
  integrations: [
    new CaptureConsoleIntegration(
    {
      // array of methods that should be captured
      // defaults to ['log', 'info', 'warn', 'error', 'debug', 'assert']
      levels: ['error'],
    }),
    // new OfflineIntegration(),
  ],
});
